import Link from 'next/link';
import { BoxProps, Stack } from '@mui/material';
import SvgIconStyle from './SvgIconStyle';

export default function InfoLink({ sx }: BoxProps) {
  const styles = {
    container: { px: 3, pb: 3, mt: 10, width: 1, textAlign: 'center', display: 'block' },
    icon: { width: 32, height: 32, ...sx, backgroundColor: 'common.white' },
  };
  const icon = (
    <Stack spacing={3} sx={styles.container}>
      <SvgIconStyle src="/icons/iconly/light/info_square.svg" sx={styles.icon} />
    </Stack>
  );

  // TODO: the link doesn't work, replace or delete
  return <Link href="/help">{icon}</Link>;
}
